/**
 * Javascript for the thumbnail hover peek feature on the PDP
 */
define([
    'jquery',
    'Magento_Customer/js/customer-data',
    'notifications'
], function ($, customerData, Notifications) {
    'use strict';

    /**
     * @param {Object} config Parameters passed into this component
     */
    return function(config) {
        initSaveForLaterButton(config.eventAnchor);
    };

    /**
     * Initialise the click handler on the save for later button that is on the PLP and PDP
     *
     * @param {string} eventAnchor CSS selector of a parent level element to the save for later/add to wishlist button
     *
     * @return null
     */
    function initSaveForLaterButton(eventAnchor) {
        $(eventAnchor).on('click', '[data-action="add-to-wishlist"]', handlerSaveForLaterButton);
    }

    /**
     * Handle the even when a save for later button is clicked
     *
     * @param e
     *
     * @return null
     */
    function handlerSaveForLaterButton(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        sendAJAXRequest($(this));
    }

    /**
     * CDP Send the required date to the datalayer to save an item to the wishlist
     */
    function cdpWishlist(itemId = undefined) {

        // CDP addToWishList data push to datalayer
        var dataLayer = window.dataLayer || [];

        if(dataLayer.find(item => item.event === "view_item")){
            var datalayerObject = dataLayer;
            var currency, productId,
                productName, productPrice,
                productQuantity, productGender,
                productFhid, productCategories,
                banner, productSize, productUrl,
                productImage;

            if(storeName && storeName !== undefined){
                banner = storeName;
            }else{
                banner = "";
            }

            //banner = datalayerObject[0].Banner;
            productSize = $('.swatch-option.text.selected').text();

            for (var obj of datalayerObject) {
                if (obj.event === "view_item") {
                    currency = obj.ecommerce.items[0].currency;
                    productId = obj.ecommerce.items[0].item_id;
                    productName = obj.ecommerce.items[0].item_name;
                    productPrice = obj.ecommerce.items[0].price;
                    productQuantity = obj.ecommerce.items[0].quantity;
                    productGender = obj.ecommerce.items[0].gender;
                    productFhid = obj.ecommerce.items[0].fredhopperID;
                    productCategories = obj.ecommerce.items[0].item_category;
                    productUrl = obj.ecommerce.items[0].product_url;
                    productImage = obj.ecommerce.items[0].product_image;
                    break;
                }
            };

            dataLayer.push({
                'event': 'addToWishList',
                'ecommerce': {
                    'currencyCode': currency,
                    'add': {
                        'products': [{
                            'id': productId,
                            'name': productName,
                            'price': productPrice,
                            'quantity': productQuantity,
                            'gender': productGender,
                            'fhId': productFhid,
                            'web_categories': productCategories,
                            'product_url':productUrl,
                            'product_image': productImage,
                            'banner': banner
                        }]
                    }
                }
            });

            // GA4 DataLayer Push - add_to_wishlist event
            dataLayer.push({
                'event': 'add_to_wishlist',
                'ecommerce': {
                    'currency': currency,
                    'items': [{
                        'item_id':productId,
                        'item_name': productName,
                        'price': productPrice,
                        'quantity': productQuantity,
                        'gender': productGender,
                        'fhId': productFhid,
                        'web_categories': productCategories,
                        'product_url':productUrl,
                        'product_image': productImage,
                        'banner': banner
                    }]
                }
            });
        }else {
            if (itemId !== undefined && dataLayer.find(item => item.event === "view_item_list") && document.body.classList.contains('catalog-category-view')) {
                var currency, productId,
                    productName, productPrice,
                    productGender, productCategories,
                    banner, productSize, productUrl,
                    productImage;

                if(storeName && storeName !== undefined){
                    banner = storeName;
                }else{
                    banner = "";
                }

                if(window.location.hostname.includes(".au")){
                    currency = "AUD"
                }else if(window.location.hostname.includes(".nz")) {
                    currency = "NZD"
                }

                //banner = datalayerObject[0].Banner;
                productSize = $('.swatch-option.text.selected').text();

                const viewItemListEvent = dataLayer.find(item => item.event === "view_item_list");
                const item = viewItemListEvent.ecommerce.items.find(i => i.item_id === itemId);

                if (item) {
                    productId = item.item_id;
                    productName = item.item_name;
                    productPrice = item.price;
                    productGender = item.gender;
                    productCategories = item.web_category;
                    productUrl = item.product_image;
                    productImage = item.product_url;
                }

                dataLayer.push({
                    'event': 'addToWishList',
                    'ecommerce': {
                        'currencyCode': currency,
                        'add': {
                            'products': [{
                                'id': productId,
                                'name': productName,
                                'price': productPrice,
                                'gender': productGender,
                                'web_categories': productCategories,
                                'product_url':productUrl,
                                'product_image': productImage,
                                'banner': banner
                            }]
                        }
                    }
                });

                // GA4 DataLayer Push - add_to_wishlist event
                dataLayer.push({
                    'event': 'add_to_wishlist',
                    'ecommerce': {
                        'currency': currency,
                        'items': [{
                            'item_id':productId,
                            'item_name': productName,
                            'price': productPrice,
                            'gender': productGender,
                            'web_categories': productCategories,
                            'product_url':productUrl,
                            'product_image': productImage,
                            'banner': banner
                        }]
                    }
                });
            }
        }
    }

    /**
     * Send the request to the server to save an item to the wishlist
     *
     * @param {jQuery} $button The Save for Later button that was clicked
     *
     * @return null
     */
    function sendAJAXRequest($button) {
        var postData = JSON.parse($button.attr('data-post')).data;
        var itemId
        if(postData.itemId){
            itemId = postData.itemId;
        }
        //Grab the form key from the hidden input on the page, and attach it to the post data
        postData.form_key = $('input[name="form_key"]').val();

        // If there is an add-to-cart form, also pass along the corresponding buyRequest so we can save the selected configuration.
        var $addToCartForm = $('#product_addtocart_form, #add-to-bag-form');
        // Don't attempt this if we're adding to wishlist from a PLP tile, since it will either use empty values or stale ones from the hidden quickview form.
        if ($addToCartForm.length && !$button.hasClass('product-tile__action--add-to-wishlist')) {
            $addToCartForm.first().serializeArray().forEach(function(formField){
                if(formField['value'] !== "") {
                    postData[formField['name']] = formField['value'];
                }
            });
        }

        $.ajax({
            url: "/munro_wishlist/index/ajaxadd",
            type: 'POST',
            data: postData
        })
            .done(function(data) {
                if (data.success) {
                    $button.find("span").text('Saved!');
                    if(data.success_message) {
                        Notifications.createSuccessNotification(data.success_message);
                    }
                    //This will invalidate the wishlist variable saved locally and force Magento to reload it from the server
                    customerData.reload(['wishlist'], true);

                    // CDP Wishlist function execute.
                    cdpWishlist(itemId);
                }
                else if(typeof(data.redirect) !== 'undefined') {
                    window.location.href = data.redirect;
                }
            });
    }
});
